import { ValidationStatus } from '@onwardtravelsolutions/package-react/Enums';
import Validation from '../Types/Validation';

export function getValidation(status: ValidationStatus): Validation {
    return {
        status,
        backgroundClasses:
            {
                [ValidationStatus.Unknown]: 'bg-gray-200 dark:bg-neutral-500',
                [ValidationStatus.Hard]: 'bg-error',
                [ValidationStatus.Soft]: 'bg-orange-200',
                [ValidationStatus.Valid]: 'bg-green-400',
                [ValidationStatus.Pending]: 'bg-blue-200 dark:bg-blue-400',
            }[status] ?? 'bg-gray-200 dark:bg-neutral-500',
        borderClasses:
            {
                [ValidationStatus.Unknown]:
                    'border-gray-200 dark:border-neutral-500',
                [ValidationStatus.Hard]: 'border-error',
                [ValidationStatus.Soft]: 'border-orange-300',
                [ValidationStatus.Valid]: 'border-green-400',
                [ValidationStatus.Pending]:
                    'border-blue-200 dark:border-blue-400',
            }[status] ?? 'border-gray-200 dark:border-neutral-500',
    };
}
